/**
 * How the Green Button drawer applies data to the proposal.
 * - `v1`: V1 Solar and Battery. Switch, resume and confirm call V1's
 *   endpoints, which recalculate the proposal.
 * - `selection_only`: Solar V2. They call V2's endpoints, which change only
 *   the consumption selection, so savings read out of date afterwards.
 * Connect, homeowner email, retry, linking, meter selection, status and
 * insights are Site-level and behave the same in both.
 */
export type GreenbuttonApplyMode = `selection_only` | `v1`

export const SELECTION_ONLY_APPLIED_COPY = `Green Button usage applied. Savings are now out of date.`

export const SELECTION_ONLY_PENDING_IMPORT_COPY = `Green Button will be used when the import finishes.`

export const SELECTION_ONLY_NEWER_DATA_COPY = `Newer Green Button data is available.`

export const SELECTION_ONLY_GRID_IMPORT_COPY = `Grid-import data measures net grid usage, so it understates household usage for solar sizing.`

export const SELECTION_ONLY_MANUAL_SOURCE_COPY = `To use manual usage instead, enter it in the Consumption step.`
